export default __webpack_public_path__ + "static/media/thin.5ace67c1.svg";